module.exports = __webpack_public_path__ + "static/icon-quality-f9d1ea8ec4e9e6301805b71391498964.png";